import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  success: null,
  resendCooldown: 0
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    
    clearError: (state) => {
      state.error = null;
    },
    
    setSuccess: (state, action) => {
      state.success = action.payload;
      state.isLoading = false;
    },
    
    clearSuccess: (state) => {
      state.success = null;
    },
    
    startResendCooldown: (state) => {
      state.resendCooldown = 30; // 30 seconds cooldown
    },
    
    decrementCooldown: (state) => {
      if (state.resendCooldown > 0) {
        state.resendCooldown -= 1;
      }
    },
    
    resetCooldown: (state) => {
      state.resendCooldown = 0;
    }
  }
});

export const { 
  setLoading, 
  setError, 
  clearError, 
  setSuccess, 
  clearSuccess,
  startResendCooldown,
  decrementCooldown,
  resetCooldown
} = uiSlice.actions;

export default uiSlice.reducer;